import { snakeCaseToTitle } from "./util";

export const facetsMapping = {
  'learning_level': 'Learning Level',
  'administrator': 'Administrator',
  'user_type': 'User',
  'product': 'Product',
  'prek-12': 'PreK-12',
  'highered': 'Higher Ed',
  'simnet': 'SIMnet®',
  'aleks': 'ALEKS®',
  'go': 'GO',
  'ebookshelf': 'eBookshelf',
  'connected': 'ConnectED',
  'anatomy physiology revealed': 'Anatomy & Physiology Revealed®',
  'testbuilder': 'Test Builder',
  'smartbook': 'SmartBook',
  'connect': 'Connect®',
  'create': 'Create®',
  'created_by_division': 'Created By Division',
};

export function getFacetLabel(key: string) {
  if (facetsMapping[key]) {
    return facetsMapping[key];
  } 
  return snakeCaseToTitle(key);
}

export function getNbspFacetLabels(keys: Array<string>) {
  return getFacetLabels(keys).map((label) => label.replace(/ /g, "\u00A0"));
}
export function getFacetLabels(keys: Array<string>) {
  const labels: Array<string> = [];
  if (typeof keys === 'string') {
    keys = [keys];
  } 
  if (keys && Array.isArray(keys)) {
    keys.forEach(key => {
      if (facetsMapping[key]) {
        labels.push(facetsMapping[key]);
      } else {
        labels.push(snakeCaseToTitle(key));
      }
    });
  }
  
  return labels
}
